/*
 * Barely There Skin Tint PDP — Skin Match Studio layer on top of <kiro-product-page-v3> (kiro-v3-pdp.js).
 * v3 owns shade switching, price, cart and the sticky bar; this file adds the On skin / Find my shade tabs,
 * depth filters, shade label, the two-photo swipe and the zoom dialog. Everything below the buy box is PDP v3 page modules.
 * It listens to v3's kiro:pdp:ready / kiro:pdp:shade-change events and calls root.select(handle) to change shade.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function text(el, value) { if (el && el.textContent !== value) el.textContent = value; }

  function init(root) {
    if (root.__stReady) return;
    var dataEl = $(root, '[data-st-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.__stReady = true;

    // Order = storeV2.product_listingV2 "index" (else the Shade block order).
    var shades = (data.shades || []).slice().sort(function (x, y) { return (Number(x.order) || 0) - (Number(y.order) || 0); });
    var byHandle = {};
    shades.forEach(function (s) { byHandle[s.handle] = s; });
    var state = { tab: data.defaultTab || 'onskin', photo: 'finish', handle: data.current };

    /* ---------- Tabs: On skin (ours) / Product (v3) / Find my shade (ours) ---------- */
    var tabs = $$(root, '[data-st-tab]');
    function syncTabs() {
      root.dataset.stView = state.tab;
      tabs.forEach(function (t) {
        var on = t.dataset.stTab === state.tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      });
      $$(root, '[data-st-panel]').forEach(function (p) { p.hidden = p.dataset.stPanel !== state.tab; });
    }
    function setTab(name) {
      state.tab = name;
      if (name === 'product' && typeof root.setView === 'function') root.setView('product');
      syncTabs();
    }
    function scrollToStudio() {
      var hero = $(root, '.st-hero');
      if (hero) hero.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { setTab(t.dataset.stTab); });
    });
    var tablist = $(root, '.st-tabs');
    if (tablist) tablist.addEventListener('keydown', function (e) {
      var keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (keys.indexOf(e.key) < 0) return;
      var i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      e.stopPropagation();
      var next = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      setTab(tabs[next].dataset.stTab);
      tabs[next].focus();
    }, true);
    root.addEventListener('click', function (e) {
      var go = e.target.closest('[data-st-goto]');
      if (!go || !root.contains(go)) return;
      setTab(go.dataset.stGoto);
      scrollToStudio();
    });

    /* ---------- Selected shade: label and on-skin photos ---------- */
    var onskinImg = $(root, '[data-st-onskin-img]');
    var beforeImg = $(root, '[data-st-before-img]');
    var beforeSlide = $(root, '[data-st-slide="before"]');
    var track = $(root, '[data-st-track]');
    var stage = $(root, '[data-st-stage]');
    function swap(img, src, alt) {
      if (!img) return;
      if (src && img.getAttribute('src') !== src) {
        img.removeAttribute('width');
        img.removeAttribute('height');
        img.src = src;
        img.classList.remove('st-in');
        void img.offsetWidth;
        img.classList.add('st-in');
      }
      img.hidden = !src;
      img.alt = alt;
    }
    // The photo buttons and the swipe track stay in sync: buttons scroll the track, scrolling updates the buttons.
    function paintPhoto() {
      if (stage) stage.classList.toggle('is-before', state.photo === 'before');
      $$(root, '[data-st-photo]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.stPhoto === state.photo)); });
    }
    function scrollToPhoto(smooth) {
      if (!track) return;
      var slide = $(track, '[data-st-slide="' + state.photo + '"]');
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: smooth && !reduced.matches ? 'smooth' : 'auto' });
    }
    if (track) {
      var trackTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(trackTimer);
        trackTimer = setTimeout(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          var next = i >= 1 && beforeSlide && !beforeSlide.hidden ? 'before' : 'finish';
          if (next !== state.photo) { state.photo = next; paintPhoto(); }
        }, 60);
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        state.photo = e.key === 'ArrowRight' && beforeSlide && !beforeSlide.hidden ? 'before' : 'finish';
        paintPhoto();
        scrollToPhoto(true);
      });
    }
    function render() {
      var s = byHandle[state.handle];
      if (!s) return;
      $$(root, '[data-st-code]').forEach(function (el) { text(el, s.code); });
      $$(root, '[data-st-depth]').forEach(function (el) { text(el, s.depth); });
      $$(root, '[data-st-tone]').forEach(function (el) { text(el, s.tone); });
      var dot = $(root, '[data-st-sticky-dot]');
      if (dot) dot.style.background = s.color;
      swap(onskinImg, s.model || s.before, s.code + ' on real skin');
      swap(beforeImg, s.before, s.code + ' before and after');
      if (beforeSlide) beforeSlide.hidden = !s.before;
      paintPhoto();
      renderMatches();
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-st-photo]');
      if (!b || !root.contains(b)) return;
      state.photo = b.dataset.stPhoto === 'before' && beforeSlide && !beforeSlide.hidden ? 'before' : 'finish';
      paintPhoto();
      scrollToPhoto(true);
    });
    // Broken image -> keep the frame, explain instead of showing a broken icon.
    root.addEventListener('error', function (e) {
      if (e.target.tagName !== 'IMG' || !e.target.closest('.st-photo-window')) return;
      e.target.style.opacity = '0';
      e.target.parentElement.setAttribute('data-image-error', 'Image unavailable — try another view');
    }, true);
    root.addEventListener('load', function (e) {
      if (e.target.tagName !== 'IMG') return;
      e.target.style.opacity = '';
      if (e.target.parentElement) e.target.parentElement.removeAttribute('data-image-error');
    }, true);

    function changeShade(handle) {
      if (!handle) return;
      state.handle = handle;
      if (state.photo === 'before' && !(byHandle[handle] || {}).before) state.photo = 'finish';
      render();
      scrollToPhoto(false);
      syncTabs(); // v3 re-applies its own tab state on every render.
      fixShadeNames(handle);
    }
    // v3 fills [data-kp-shade-name] (under the product title) and [data-kp-sticky-shade] (sticky bar) via pdp_details /
    // productV2 first. Use s.name instead: the variantV2 metafield general_detail.shade_name, else the listing shade_name
    // (set in sections/kiro-skin-tint-pdp.liquid). v3 renders before it fires shade-change, so this runs last.
    function fixShadeNames(handle) {
      var s = byHandle[handle];
      if (!s) return;
      var name = s.name || (s.code + ' ' + s.depth);
      text($(root, '[data-kp-shade-name]'), name);
      text($(root, '[data-kp-sticky-shade]'), name);
    }
    root.addEventListener('kiro:pdp:shade-change', function (e) { changeShade(e.detail && e.detail.handle); });
    root.addEventListener('kiro:pdp:ready', function (e) { changeShade((e.detail && e.detail.handle) || state.handle); });

    function selectShade(handle) {
      if (typeof root.select === 'function' && root.ready) root.select(handle);
      else location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + handle;
    }

    /* ---------- Depth filters (same clone approach as PDP v3's colour filters) ---------- */
    var bar = $(root, '[data-kp-pf]');
    var strip = $(root, '[data-kp-shades]');
    var map = {};
    try { map = JSON.parse(($(root, '[data-kp-pf-map]') || {}).textContent || '{}'); } catch (e) {}
    function norm(v) { return String(v || '').trim().toLowerCase(); }
    function applyFilter(button) {
      if (!bar || !strip) return;
      $$(bar, 'button').forEach(function (b) { b.setAttribute('aria-pressed', String(b === button)); });
      $$(strip, '[data-kp-pf-group]').forEach(function (el) { el.remove(); });
      var originals = $$(strip, '[data-kp-shade]');
      var families = (button.dataset.kpPfFamilies || '').split('|').map(norm).filter(Boolean);
      if (!families.length) { originals.forEach(function (d) { d.removeAttribute('data-kp-pf-off'); }); return; }
      var fragment = document.createDocumentFragment();
      originals.forEach(function (dot) {
        dot.setAttribute('data-kp-pf-off', '');
        var groups = (map[dot.dataset.kpShade] || []).map(norm);
        if (!families.some(function (f) { return groups.indexOf(f) > -1; })) return;
        var clone = dot.cloneNode(true);
        clone.removeAttribute('data-kp-pf-off');
        clone.setAttribute('data-kp-pf-group', '');
        fragment.appendChild(clone);
      });
      if (!fragment.childNodes.length) {
        var empty = document.createElement('p');
        empty.className = 'st-empty';
        empty.setAttribute('data-kp-pf-group', '');
        empty.textContent = 'No ' + button.textContent.trim() + ' shades yet';
        fragment.appendChild(empty);
      }
      strip.appendChild(fragment);
    }
    if (bar) bar.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (b && bar.contains(b)) applyFilter(b);
    });
    function resetFilter() { var all = bar && $(bar, 'button'); if (all) applyFilter(all); }

    /* ---------- Find my shade: 2-step quiz (start → skin depth → jewellery → result) ---------- */
    // Q1 groups use the same data as the shade filters (map = FILTER_COLOR, else the Shade block depth).
    // Q2: Gold = Warm, Silver = Cool, Both = Neutral; when the depth has no shade with that undertone, every shade in the depth is shown.
    var quiz = $(root, '[data-st-quiz]');
    var hint = $(root, '[data-st-hint]');
    var answer = { families: [], groupLabel: '', tone: '' };
    function groupsOf(s) { return (map[s.handle] || [s.depth]).map(norm); }
    function inGroup(s, families) { var g = groupsOf(s); return families.some(function (f) { return g.indexOf(f) > -1; }); }
    function showStep(name) {
      if (!quiz) return;
      $$(quiz, '[data-st-step]').forEach(function (st) { st.hidden = st.dataset.stStep !== name; });
      var route = $(quiz, '[data-st-foundation-route]');
      if (route) route.hidden = name !== 'start';
      var first = $(quiz, '[data-st-step="' + name + '"] .st-quiz-q, [data-st-step="' + name + '"] .st-quiz-title');
      if (first) { first.setAttribute('tabindex', '-1'); first.focus({ preventScroll: true }); }
    }
    if (quiz) {
      // Start screen: one swatch per shade; Q1 circles: the middle shade of each group.
      // (own name: a 'strip' var here would shadow the shade filter's swatch strip, since var is function-scoped)
      var quizStrip = $(quiz, '[data-st-quiz-strip]');
      if (quizStrip) shades.forEach(function (s) { var i = document.createElement('i'); i.style.background = s.color; quizStrip.appendChild(i); });
      $$(quiz, '[data-st-q1]').forEach(function (b) {
        var fam = b.dataset.stQ1.split('|').map(norm).filter(Boolean);
        var list = shades.filter(function (s) { return inGroup(s, fam); });
        var mid = list[Math.floor((list.length - 1) / 2)];
        if (mid) $(b, '[data-st-q1-color]').style.background = mid.color;
        if (!list.length) b.hidden = true;
      });
      quiz.addEventListener('click', function (e) {
        var go = e.target.closest('[data-st-quiz-go]');
        if (go) { showStep(go.dataset.stQuizGo); return; }
        var q1 = e.target.closest('[data-st-q1]');
        if (q1) {
          answer.families = q1.dataset.stQ1.split('|').map(norm).filter(Boolean);
          answer.groupLabel = $(q1, 'span').textContent.trim();
          $$(quiz, '[data-st-q1]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === q1)); });
          showStep('q2');
          return;
        }
        var q2 = e.target.closest('[data-st-q2]');
        if (q2) {
          answer.tone = q2.dataset.stQ2;
          var resultBack = $(quiz, '[data-st-step="result"] .st-quiz-back');
          if (resultBack) resultBack.dataset.stQuizGo = 'q2';
          $$(quiz, '[data-st-q2]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === q2)); });
          renderMatches();
          showStep('result');
        }
      });
    }
    function renderMatches() {
      if (!answer.families.length) return;
      var inDepth = shades.filter(function (s) { return inGroup(s, answer.families); });
      var list = inDepth.filter(function (s) { return String(s.tone).toLowerCase().indexOf(answer.tone.toLowerCase()) === 0; });
      var exact = list.length > 0;
      if (!exact) list = inDepth;
      showMatch(list, exact ? '' : 'No ' + answer.tone.toLowerCase() + ' shade in ' + answer.groupLabel + ', so this is the closest ' + answer.groupLabel + ' match.');
    }

    /* ---------- Result: "Your perfect match" (main shade, "Also try", tip, Add to bag) ---------- */
    // Main shade = first match. "Also try" = the next match when there are several, otherwise the nearest shade
    // (by listing order) with the same undertone, else the nearest shade. Price / variant come from each shade's product.
    var TONE_TEXT = { warm: 'a warm, golden undertone', cool: 'a cool, rosy undertone', neutral: 'a balanced, neutral undertone' };
    var match = { list: [], main: null, alt: null };
    function toneWord(s) { return norm(String(s.tone || '').split(/[\s+]+/)[0]); }
    function alternateFor(main, list) {
      var others = list.filter(function (s) { return s !== main; });
      if (others.length) return others[0];
      var i = shades.indexOf(main);
      for (var d = 1; d < shades.length; d++) {
        var deeper = shades[i + d], lighter = shades[i - d];
        if (deeper && toneWord(deeper) === toneWord(main)) return deeper;
        if (lighter && toneWord(lighter) === toneWord(main)) return lighter;
      }
      return shades[i + 1] || shades[i - 1] || null;
    }
    function paintMatch(main, alt) {
      match.main = main;
      match.alt = alt;
      var depth = String(main.depth || '');
      $(root, '[data-st-match-swatch]').style.background = main.color;
      text($(root, '[data-st-match-code]'), main.code);
      text($(root, '[data-st-match-depth]'), depth);
      text($(root, '[data-st-match-desc]'), (depth.charAt(0).toUpperCase() + depth.slice(1).toLowerCase()) + ' skin with ' +
        (TONE_TEXT[toneWord(main)] || 'a ' + String(main.tone || '').toLowerCase() + ' undertone') + '.');
      var altBtn = $(root, '[data-st-match-alt]');
      altBtn.hidden = !alt;
      if (alt) {
        $(altBtn, 'i').style.background = alt.color;
        text($(altBtn, 'b'), alt.code);
        text($(altBtn, '[data-st-match-rel]'), shades.indexOf(alt) > shades.indexOf(main) ? 'a shade deeper' : 'a shade lighter');
      }
      var add = $(root, '[data-st-match-add]');
      add.disabled = !main.available || !main.variantId;
      text(add, main.available ? 'Add ' + main.code + ' to bag' + (main.price ? ' · ' + main.price : '') : main.code + ' is sold out');
      var status = $(root, '[data-st-match-status]');
      if (status) status.hidden = true;
    }
    function showMatch(list, note, image, imageAlt) {
      match.list = list;
      paintMatch(list[0], alternateFor(list[0], list));
      var noteEl = $(root, '[data-st-match-note]');
      text(noteEl, note || '');
      noteEl.hidden = !note;
      showResultImage(image || '', imageAlt);
    }
    function showResultImage(src, alt) {
      var img = $(root, '[data-st-result-img]');
      if (!img) return;
      if (src) { img.src = src; img.alt = alt || ''; }
      img.hidden = !src;
    }
    /* ---------- Add to Bag: same flow as the theme's ".addtocart.action" buttons ----------
       Cart: assets/main-minified.js addToCart_new() — POST /cart/update.js { updates: { [variantId]: quantity already in the
       bag + new quantity } } (max 5 per shade, getTotalVariantQty), then window.showCartLively() → re_render_cart() refreshes
       and opens the theme cart drawer (count, subtotal, offers, complete the look, pouch eligibility).
       Tracking: sections/footer.liquid ".addtocart.action" click handler — Meta AddToCart, Snapchat ADD_CART, Google Ads
       conversions (AW-608802853, AW-10785885514) and Universal Analytics ec:addProduct, with the same fields the theme
       reads from the button (fbname = product title, fbcollection, fbsku = barcode, fbprice, pid).
       Used by the main Add to Bag, the sticky Add to Bag (both submit the v3 form) and the quiz result button. */
    var MAX_PER_SHADE = 5;
    var cartRoot = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    function cartJSON() {
      return fetch(cartRoot + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }
    function trackAddToCart(item) {
      var price = Math.round(Number(item.priceCents || 0)) / 100;
      var category = String(item.collection || '').toLowerCase();
      try { if (typeof window.fbq === 'function') window.fbq('track', 'AddToCart', { content_name: item.title, content_category: category, content_ids: [item.barcode], content_type: 'product', value: price, currency: 'INR' }); } catch (e) {}
      setTimeout(function () {
        cartJSON().then(function (cart) {
          var skus = cart.items.map(function (line) { return String(line.sku || '').replace('DEACT', ''); });
          try { if (typeof window.snaptr === 'function') window.snaptr('track', 'ADD_CART', { price: cart.original_total_price / 100, currency: 'INR', item_ids: skus, number_items: cart.item_count, uuid_c1: cart.token }); } catch (e) {}
        }).catch(function () {});
      }, 3000);
      try { if (typeof window.gtag === 'function') window.gtag('event', 'conversion', { send_to: 'AW-608802853/CepaCIiP7d4BEKWwpqIC', ecomm_prodid: String(item.productId), items: [{ id: item.barcode, name: item.title }] }); } catch (e) {}
      try { if (typeof window.gtag2 === 'function') window.gtag2('event', 'conversion', { send_to: 'AW-10785885514/-u7LCPndmPoCEMqajpco' }); } catch (e) {}
      try {
        if (typeof window.ga === 'function') {
          window.ga('ec:addProduct', { id: item.barcode, name: item.title, category: category, brand: 'Kiro', variant: item.title, price: price, quantity: item.quantity });
          window.ga('ec:setAction', 'add');
          window.ga('send', 'event', 'UX', 'click', 'add to cart');
        }
      } catch (e) {}
    }
    // item: { variantId, productId, quantity, title, collection, barcode, priceCents }
    function addToBag(item) {
      var qty = Math.max(1, parseInt(item.quantity, 10) || 1);
      return cartJSON().then(function (cart) {
        var inBag = cart.items.reduce(function (n, line) { return n + (line.variant_id === Number(item.variantId) ? line.quantity : 0); }, 0);
        if (inBag >= MAX_PER_SHADE) throw new Error('You already have ' + MAX_PER_SHADE + ' of this shade in your bag (max ' + MAX_PER_SHADE + ').');
        var total = Math.min(MAX_PER_SHADE, inBag + qty);
        var body = new URLSearchParams();
        body.append('updates[' + parseInt(item.variantId, 10) + ']', String(total));
        return fetch(cartRoot + 'cart/update.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body });
      }).then(function (r) {
        return r.json().then(function (res) { if (!r.ok) throw new Error(res.description || res.message || 'Could not add to bag'); return res; });
      }).then(function (cart) {
        trackAddToCart({ productId: item.productId, title: item.title, collection: item.collection, barcode: item.barcode, priceCents: item.priceCents, quantity: qty });
        if (typeof window.showCartLively === 'function') window.showCartLively();
        document.dispatchEvent(new CustomEvent('kiro:skin-tint:cart-added', { detail: { variantId: item.variantId, quantity: qty } }));
        return cart;
      });
    }
    // Main + sticky Add to Bag submit the v3 form: take that submit over (capture phase, before kiro-v3-pdp.js) and run addToBag.
    root.addEventListener('submit', function (e) {
      var formEl = e.target;
      if (!formEl.matches || !formEl.matches('.kp-form')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var cur = root.current;
      if (!cur || !cur.variant || !cur.variant.available) return;
      var info = byHandle[cur.handle] || {};
      var buttons = $$(root, '[data-kp-add]');
      var error = $(root, '[data-kp-error]');
      if (error) error.hidden = true;
      buttons.forEach(function (b) { b.disabled = true; text(b, 'Adding…'); });
      var restore = function () { buttons.forEach(function (b) { b.disabled = !(root.current && root.current.variant && root.current.variant.available); text(b, b.disabled ? 'Sold out' : 'Add to Bag'); }); };
      addToBag({
        variantId: cur.variant.id,
        productId: cur.id,
        quantity: ($(root, '[data-kp-quantity]') || {}).value,
        title: info.title || cur.title,
        collection: info.collection || '',
        barcode: cur.variant.barcode || info.barcode || '',
        priceCents: cur.variant.price
      }).then(restore).catch(function (err) {
        restore();
        if (error) { text(error, err.message || 'Could not add to bag. Please try again.'); error.hidden = false; }
      });
    }, true);
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-st-match-alt]') && match.alt) {
        var next = match.alt;
        paintMatch(next, match.main);
        return;
      }
      var add = e.target.closest('[data-st-match-add]');
      if (!add || add.disabled || !match.main) return;
      var shade = match.main;
      var status = $(root, '[data-st-match-status]');
      add.disabled = true;
      text(add, 'Adding…');
      addToBag({ variantId: shade.variantId, productId: shade.productId, quantity: 1, title: shade.title, collection: shade.collection, barcode: shade.barcode, priceCents: shade.priceCents })
        .then(function () {
          text(add, shade.code + ' added to bag ✓');
          setTimeout(function () { if (match.main === shade) paintMatch(shade, match.alt); }, 2500);
        }).catch(function (err) {
          paintMatch(shade, match.alt);
          if (status) { text(status, err.message || 'Could not add to bag. Please try again.'); status.hidden = false; }
        });
    });

    /* ---------- "I know my foundation shade": Brand → Foundation → Your shade → matched skin tint ---------- */
    // Data: shop metafield skin_products.shade_finder["barely-there-skin-tint"].brands, passed in by the section as
    //   [{ brand, foundations: [{ name, shades: [{ name, match: mapped_product_handle[], image: before_after_image URL }] }] }].
    // "match" may also be a skin tint code ("25W"). Nothing is guessed when data is missing.
    var form = $(root, '[data-st-foundation]');
    if (form) {
      var fData = [];
      try { fData = JSON.parse(($(root, '[data-st-foundation-data]') || {}).textContent || 'null') || []; } catch (e) {}
      if (!Array.isArray(fData)) fData = [];
      var pending = $(root, '[data-st-pending]');
      var brandSel = $(form, '[data-st-brand]');
      var prodSel = $(form, '[data-st-fprod]');
      var shadeSel = $(form, '[data-st-fshade]');
      var submit = $(form, '[type=submit]');
      var brandEntry = function () { return fData.filter(function (b) { return norm(b.brand) === norm(brandSel.value); })[0]; };
      var prodEntry = function () { var b = brandEntry(); return b && (b.foundations || []).filter(function (f) { return norm(f.name) === norm(prodSel.value); })[0]; };
      var fill = function (sel, placeholder, items) {
        sel.replaceChildren();
        var first = document.createElement('option'); first.value = ''; first.textContent = placeholder; sel.appendChild(first);
        items.forEach(function (name) { var o = document.createElement('option'); o.value = name; o.textContent = name; sel.appendChild(o); });
        sel.disabled = !items.length;
      };
      var findShade = function (ref) {
        var r = norm(ref);
        return shades.filter(function (s) { return norm(s.code) === r || norm(s.handle) === r; })[0];
      };
      var hidePending = function () { if (pending) pending.hidden = true; };
      // The theme turns every <select> into a jQuery "nice-select" (sections/footer.liquid: $('select').niceSelect()).
      // Its fake dropdown fires jQuery-only change events and never refreshes options / disabled state, so the
      // dependent Brand → Foundation → Shade dropdowns stay native here. Runs after the footer's ready handler.
      var keepNative = function () {
        var jq = window.jQuery;
        [brandSel, prodSel, shadeSel].forEach(function (sel) {
          if (jq && jq.fn && jq.fn.niceSelect && sel.nextElementSibling && sel.nextElementSibling.classList.contains('nice-select')) jq(sel).niceSelect('destroy');
          var fake = sel.nextElementSibling;
          if (fake && fake.classList.contains('nice-select')) fake.remove();
          sel.style.display = '';
        });
      };
      if (window.jQuery) window.jQuery(keepNative);
      window.addEventListener('load', keepNative);
      keepNative();
      if (window.MutationObserver) new MutationObserver(function (records) {
        if (records.some(function (r) { return Array.prototype.some.call(r.addedNodes, function (n) { return n.classList && n.classList.contains('nice-select'); }); })) keepNative();
      }).observe(form, { childList: true });
      brandSel.addEventListener('change', function () {
        hidePending();
        var b = brandEntry();
        fill(prodSel, 'Select foundation', b ? (b.foundations || []).map(function (f) { return f.name; }) : []);
        fill(shadeSel, 'Select shade', []);
        submit.disabled = true;
        if (brandSel.value && !b && pending) {
          text($(pending, '[data-st-pending-text]'), brandSel.value + ' matches are coming soon.');
          pending.hidden = false;
        }
      });
      prodSel.addEventListener('change', function () {
        hidePending();
        var f = prodEntry();
        fill(shadeSel, 'Select shade', f ? (f.shades || []).map(function (x) { return x.name; }) : []);
        submit.disabled = true;
      });
      shadeSel.addEventListener('change', function () { hidePending(); submit.disabled = !shadeSel.value; });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var f = prodEntry();
        var entry = f && (f.shades || []).filter(function (x) { return norm(x.name) === norm(shadeSel.value); })[0];
        var refs = entry ? [].concat(entry.match || []) : [];
        var list = refs.map(findShade).filter(Boolean);
        if (!list.length) {
          if (pending) { text($(pending, '[data-st-pending-text]'), 'No skin tint match saved for ' + shadeSel.value + ' yet.'); pending.hidden = false; }
          return;
        }
        answer.families = []; // the quiz result stays as this foundation match until the quiz is taken again
        var resultBack = $(root, '[data-st-step="result"] .st-quiz-back');
        if (resultBack) resultBack.dataset.stQuizGo = 'start';
        showMatch(list, 'Matched from ' + brandSel.value + ' ' + prodSel.value + ', ' + shadeSel.value + '.', entry.image, brandSel.value + ' ' + prodSel.value + ' ' + shadeSel.value + ' before and after');
        showStep('result');
      });
    }

    /* ---------- On-skin zoom dialog ---------- */
    var dialog = $(root, '[data-st-dialog]');
    function openDialog(title, sub, src, note) {
      if (!dialog || !src) return;
      text($(dialog, '[data-st-dialog-title]'), title);
      text($(dialog, '[data-st-dialog-sub]'), sub || '');
      text($(dialog, '[data-st-dialog-note]'), note || '');
      var img = $(dialog, '[data-st-dialog-img]');
      img.src = src;
      img.alt = title;
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
    }
    if (dialog) {
      $(dialog, '[data-st-dialog-close]').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    }
    root.addEventListener('click', function (e) {
      var zoom = e.target.closest('[data-st-zoom]');
      if (zoom && root.contains(zoom)) {
        var s = byHandle[state.handle];
        if (!s) return;
        var full = state.photo === 'before' ? (s.beforeFull || s.modelFull) : (s.modelFull || s.beforeFull);
        openDialog(s.code + ' · ' + s.depth, 'Original Kiro photography · ' + s.tone + ' undertone', full);
      }
    });

    syncTabs();
    render();
  }

  function boot(scope) {
    $$(scope || document, 'kiro-product-page-v3.st-pdp').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  // Theme editor: re-initialise when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
